import { isMuted, onMutedChange, setMuted } from '../audio/sound.js';
import { hudBar, iconButton } from './hud.js';
import { ENGLISH_OPEN, language } from '../i18n/language.js';
import { languageButton } from './language-toggle.js';
import { uiText } from './text.js';
import './inventory.css';
import './sound-toggle.css';

/**
 * The sound switch: the loudspeaker shows whether the game is heard, a click
 * turns it all on or off. One button for the whole visit: it stands in a
 * corner of the welcome screens (their title theme plays from the first
 * click), then moves into the top row of the HUD, beside the home button; a
 * zone change or a reconnect leaves it where it is.
 */
let button: HTMLButtonElement | undefined;
let frontCorner: HTMLElement | undefined;

function paint(target: HTMLButtonElement, muted: boolean): void {
  const label = uiText(muted ? 'Activer le son' : 'Couper le son');
  target.title = label;
  target.setAttribute('aria-label', label);
  target.setAttribute('aria-pressed', String(muted));
  const icon = target.querySelector<HTMLElement>('.hud-button__icon');
  if (icon !== null) {
    icon.style.backgroundImage = `url('/assets/ui/icon-sound-${muted ? 'off' : 'on'}.png')`;
  }
}

function soundButton(): HTMLButtonElement {
  button ??= (() => {
    const created = iconButton(isMuted() ? 'sound-off' : 'sound-on', 'Son');
    created.classList.add('hud-button--sound');
    created.addEventListener('click', () => {
      setMuted(!isMuted());
    });
    onMutedChange((muted) => {
      paint(created, muted);
    });
    paint(created, isMuted());
    return created;
  })();
  return button;
}

/** The switch above the welcome, roster and customisation screens. */
export function showFrontSoundToggle(): void {
  frontCorner ??= (() => {
    const corner = document.createElement('div');
    corner.className = 'front-sound';
    // The language switch shows once English is open to all, or in a browser that chose it.
    if (ENGLISH_OPEN || language() === 'en') corner.append(languageButton());
    return corner;
  })();
  frontCorner.append(soundButton());
  document.body.append(frontCorner);
}

export function showSoundToggle(): void {
  const bar = hudBar('top');
  const target = soundButton();
  // Just before the home button, whatever order the rest of the row was built in.
  const home = bar.querySelector('.hud-button--icon:not(.hud-button--sound)');
  bar.insertBefore(target, home);
  frontCorner?.remove();
}
